import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=4090bd66&scoped=true&"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js&"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4090bd66",
  null
  
)

export default component.exports